import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop({ trackLanguage = false }) {
  const location = useLocation();
  useEffect(() => {
    // Scroll to top on route change, but NOT on pure language switch.
    // We strip the leading /fr or /en so switching language while staying on the same page
    // does not trigger a scroll.
    // If trackLanguage=true, scroll on every change.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stripLang(location.pathname)]);

  return null;
}

function stripLang(pathname) {
  return pathname.replace(/^\/(fr|en)(?=\/|$)/, "") || "/";
}
